import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import { showPopupModal } from "@widgets/CommonModal";
import SnGrid from "@shared/components/Grid/SnGrid";
import { menuInfo, userInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const EXC000000000029002 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null);
  const gridApiRefL = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns1, setColums1] = useState<any[]>([]);
  const [columns2, setColums2] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any[]>([]);
  const [dataSource2, setDataSource2] = useState<any>();

  //#endregion
  //#region grid 길이 관련
  const cd_menu = Menuprops.cd_menu || "EXC000000000029002";
  const defaultSize = { panel1: "49.5%", panel2: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1); // H그리드 항목 설정
        setColums2(rtn.grid.grid2); // L그리드 항목 설정

        const params = {
          id: "exc000000000029002_01",
          params: rtn.initformData,
        };
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSave = async () => {
    try {
      const changedData = gridApiRefH.current.getChange();

      if (changedData?.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        mtl_qtioh: changedData,
      };

      await fnSave("EXC000000000029002_SAVE_01", SaveData);

      gridApiRefH.current.resetUpdate();
      await onSearch();
    } catch (error: any) {}
  };

  const onSearch = async () => {
    const modifiedRowsH = gridApiRefH.current.getChange();
    const modifiedRowsL = gridApiRefL.current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
    }
    try {
      const marginParam = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_biz: userInfo.cd_biz || "",
        g_cd_cust: userInfo.cd_cust || "",
      };
      const params = {
        id: "exc000000000029002_01",
        params: marginParam,
      };

      setDataSource1([]);
      setDataSource2([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      setDataSource2(data[1] || []);

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        gridApiRefH.current.selectAndFocusRow(0);
      }

      gridApiRefH.current.resetUpdate();
      gridApiRefL.current.resetUpdate();
    } catch (error: any) {}
  };

  const GridbtnClick = async (id: string) => {
    if (id === "btn1") {
      const selectedRows = gridApiRefH.current.api.getSelectedNodes();
      if (!selectedRows.length) return;

      for (const node of selectedRows) {
        if (!node?.data) continue;

        node.setDataValue("cd_mgmtdtl", "Y");
      }
      setTimeout(async () => {
        gridApiRefH.current.api.refreshCells({ force: true }); // Refresh to force detection
        await onSave();
      }, 50); // Small delay (50ms) to allow update detection
    }
  };
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const no_io = selectedRow.no_io;
      gridApiRefL.current.applyFilters({ no_io: no_io });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SnGrid
            
            onFocusedRowChanged={onFocusedRowChanged}
            seq={1}
            ref={gridApiRefH}
            columnConfig={columns1}
            rowData={dataSource1}
            isEditable={false}
            rowSelection="multiple"
            ischeckboxSelection={true}
            title="출하정보"
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
          minHeight={130}
        >
          <SnGrid
            
            seq={2}
            ref={gridApiRefL}
            columnConfig={columns2}
            rowData={dataSource2}
            enableExternalChart={false}
            isEditable={false}
            rowSelection="single"
            title="상세내역"
            header={
              <div style={{ width: 100 }}>
                <SnButton
                  text={"입고확인"}
                  onClick={() => {
                    GridbtnClick("btn1");
                  }}
                />
              </div>
            }
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
      </div>
    </div>
  );
});

export default EXC000000000029002;
